import React from 'react';
import {Table} from '../../ui/Table';
import {useHistory, useParams} from "react-router";
import {AppButton} from "../../ui/AppButton";
import {IntegrationAuthFieldProps} from "../../../api/integrations/IntegrationsDTO";
import {Routes} from "../../../constants/Routes";
import {pathParams} from "path-params";
import {Loader} from "../../ui/Loader";
import {IntegrationAuthFieldsItem} from './IntegrationAuthFieldsItem';

interface Props {
    readonly fields: IntegrationAuthFieldProps[];
    readonly onChange: (value: any) => void
}

export function IntegrationAuthFields({fields}: Props) {
    const history = useHistory();
    const params: any = useParams();

    return (
        <div className="test">
            <Table>
                <thead>
                <tr>
                    <th>Label</th>
                    <th>Key</th>
                    <th>Type</th>
                    <th>Required</th>
                </tr>
                </thead>
                <tbody>
                {fields ? fields?.map((item) => {
                    return (
                        <IntegrationAuthFieldsItem key={item.id} item={item}/>
                    )
                }) : <Loader/>}
                </tbody>
            </Table>
            <AppButton sx={{mt: 1}} onClick={() => {
                history.push(pathParams(Routes.IntegrationEditorAuthFieldsAdd, {id: params.id, authId: params.authId}))
            }}>Add Fields</AppButton>
        </div>
    );
}

